<template>
	<main id="app" >
		<link href="https://cdn.jsdelivr.net/npm/@mdi/font@5.x/css/materialdesignicons.min.css" rel="stylesheet">
		<link rel="preconnect" href="https://fonts.gstatic.com">
		<link rel="preconnect" href="https://fonts.gstatic.com">
		<link href="https://fonts.googleapis.com/css2?family=Asap:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,300;1,400;1,600;1,700;1,800&display=swap" rel="stylesheet">
		<v-app  >
			<router-view></router-view>
			<v-speed-dial
					v-model="fab"
					direction="right"
					bottom
					left
					fixed
					:open-on-hover="true"
					transition="slide-x-transition"
			>
			 	<template v-slot:activator>
					<v-btn
						style="left:0"
						fab
						class="btn-flotante"
						target="_blank"
						href="https://api.whatsapp.com/send?phone=+5930958848363&text=Hola, me pueden confirmar si cuentan con la siguiente medicina?"
						@click="saveWhatsappRecord"
					>
						<v-icon>{{sizeIcon}} mdi-whatsapp</v-icon>
					</v-btn>
				</template>
				<v-btn
					block
					dark
					small
					color="#f9a848"
					height="40px"
					target="_blank"
					href="https://api.whatsapp.com/send?phone=+5930958848363&text=Hola, me pueden confirmar si cuentan con la siguiente medicina?"
					@click="saveWhatsappRecord"
				>
					<div class="font-weight-bold" style="font-size:16px">Contáctanos</div> 
				</v-btn>
  
			</v-speed-dial>
		</v-app>
	</main>
</template>

<script>

import { mapMutations, mapActions } from 'vuex'

export default {
	name: 'App',
	data: () => ({
		fab:false
	}),
	computed:{
        sizeIcon(){
            return this.$vuetify.breakpoint.name == 'sm' || this.$vuetify.breakpoint.name == 'xs' ? 'mdi-36px' : 'mdi-48px'
        }
    },
	methods:{

		...mapMutations(['setUrl']),

		...mapActions(['requestApi']),
		
		saveWhatsappRecord(){
            
            this.setUrl('registro-web')
            this.requestApi({
				method: 'POST',
				data: {
                    typeStore: 'whatsapp'
                }
			})

        }

	}
}
	
</script>

<style>
	.card-info{
		background: linear-gradient(27deg, rgba(248,160,44,1) 0%, rgba(247,170,68,1) 90%);
		color:white!important;
		font-weight: bold;
		font-size: 1.4rem;
		line-height: .9;
		border-radius: 12px!important;
	}

	.postion-img-custom {
		margin: 0 auto!important;
	}
	
	.color-title{
        color:#ffaa45!important
    }

	.color-title-corporative{
        color:#26aeea!important
    }

	.font-size-custom{
		font-size: 3rem;
		line-height: 1;
	}

	.margin-breadcrumb{
		margin-left:120px!important;
		margin-right:120px!important;
	}
	.mt-165{
		margin-top: 165px!important;
	}

	.mt-180{
		margin-top: 180px!important;
	}

	.font-title{
		font-family:Asap!important;
	}

	.font-text{
		font-family: Open Sans!important;
	}

	.v-window__next, .v-window__prev {
    	margin: 0!important;
	}

	.secction-other-products{
        background:#50c994;
        width:100%;
        color:white;
    }

	.btn-quote-products{
        background: #26aeea!important;
        color:white!important
    }

	.btn-flotante {
		color: #ffffff!important; /* Color del texto */
		letter-spacing: 2px!important; /* Espacio entre letras */
		background-color: #26c867!important; /* Color de fondo */
		padding: 40px 40px!important; /* Relleno del boton */
		transition: all 300ms ease 0ms!important;
		box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1)!important;
		z-index: 99!important;
	}
	.btn-flotante:hover {
		background-color: #f9a848!important; /* Color de fondo al pasar el cursor */
		box-shadow: 0px 15px 20px rgba(0, 0, 0, 0.3)!important;
		transform: translateY(-7px);
	}
	@media only screen and (max-width: 600px) {
		.btn-flotante {
			font-size: 14px!important;
			padding: 12px 20px!important;
			bottom: 20px!important;
			right: 20px!important;
		}
	}

	@media (max-width: 959px){

		.card-info {
			bottom: 0px;
		}

		.margin-breadcrumb{
			margin-left:33px!important;
			margin-right:33px!important;
		}

		.mt-165{
			margin-top: 0px!important;
		}

		.mt-180{
			margin-top: 0px!important;
		}
	}

	@media (max-width: 957px){

		.postion-img-custom {
			margin: 0px 44%!important;
		}
	}

	@media (max-width:600px){
		.margin-breadcrumb{
			margin-left:17px!important;
			margin-right:17px!important;
		}
	}

	@media (max-width: 830px) , (max-width: 650px){

		.postion-img-custom{
			margin: 0px 42%!important;
		}
			
	}

	@media (max-width: 415px){

		.font-size-custom{
			font-size: 1.7rem;			
		}

		.postion-img-custom {
			margin: 0px 37%!important;
		}
		
	}

	@media (max-width: 386px){
		.font-size-custom{
			font-size: 2rem;			
		}

		.text-banner-home{
			padding:0 15px!important
		}
	}

	@media(max-width: 370px){

		.postion-img-custom{
			margin: 0px 35%!important;
		}
			
	}

	@media(max-width: 320px){

		.postion-img-custom{
			margin: 0px 32%!important;
		}

		.font-size-custom{
			font-size: 1.8rem;			
		}
			
	}

	@media (max-width: 290px){

		.postion-img-custom {
			margin: 0px 26%!important;
		}
	}

	
</style>
